import React, { useState } from 'react';
import { Checkbox, IconButton, Menu, MenuItem, Popover } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { FieldFilterItem, FieldType, SelectedFiltersType } from 'shared/types';

type FilterMenuPropsType = {
  filterFields: FieldFilterItem[];
  selectedFilterValues: SelectedFiltersType;
  setFilter: React.Dispatch<React.SetStateAction<SelectedFiltersType>>;
};

export const FilterMenu = ({ filterFields, selectedFilterValues, setFilter }: FilterMenuPropsType) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);

  const handleOpenFilterShowMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubMenuClick = (event: React.MouseEvent<HTMLElement>, filterTitle: string) => {
    setSelectedFilter(filterTitle);
  };

  const handleCloseSubMenu = () => {
    setSelectedFilter(null);
  };

  const handleCheckboxChange = (selectedFilter: string, filterItem: FieldType) => {
    setFilter((prev) => {
      const { filterName } = filterItem;
      const updatedFilter = [...prev[filterName]];

      if (updatedFilter.includes(filterItem.key)) {
        return {
          ...prev,
          [filterName]: updatedFilter.filter((key) => key !== filterItem.key),
        };
      }
      return {
        ...prev,
        [filterName]: [...updatedFilter, filterItem.key],
      };
    });
  };

  return (
    <div>
      <IconButton onClick={handleOpenFilterShowMenu}>
        <FilterAltOutlinedIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {filterFields.map((field) => (
          <MenuItem
            key={field.title}
            onClick={(event) => handleSubMenuClick(event, field.title)}
          >
            {field.title}
            <ArrowRightIcon />
          </MenuItem>
        ))}
      </Menu>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && Boolean(selectedFilter)}
        onClose={handleCloseSubMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {selectedFilter &&
          filterFields
            .find((field) => field.title === selectedFilter)
            ?.fields.map((filterItem) => (
              <MenuItem key={filterItem.name}>
                <Checkbox
                  checked={selectedFilterValues[filterItem.filterName].includes(filterItem.key)}
                  onChange={() => handleCheckboxChange(selectedFilter, filterItem)}
                />
                {filterItem.name}
              </MenuItem>
            ))}
      </Popover>
    </div>
  );
};
